module.exports = __webpack_public_path__ + "static/media/sig_original.3e5f5778.png";